// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1646":"e08728d6bd77eccc","1844":"fa111486b1092dd7","3177":"5c7523ae14de55b8","3451":"46820c5579b4913c","7827":"eff921b9dca34840","7911":"72c92ed06c79773b"}[chunkId] + ".css";
};